<template>
  <transition>
    <div class="soc_video_left_panel content-left">
      <div class="soc_panel_container content">
        <div class="soc-card tabs">
          <!--tab切换面板-->
          <div class="video_left_header">
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick"
              style="height: 100%"
            >
              <el-tab-pane label="监控点" name="first">
                <div class="first-video tab-main">
                  <!--过滤查询条件-->
                  <div class="soc_tab_panel">
                    <div class="filter_div">
                      <el-select
                        v-model="deviceType"
                        placeholder="功能选择"
                        class="filter_select"
                        @change="handleType"
                      >
                        <el-option
                          v-for="item in typeData"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <div class="filter-input">
                        <el-input
                          v-model="filterContent"
                          placeholder="摄像头名称"
                          @change="searchChange"
                        ></el-input>
                        <div class="filter-input_btn">
                          <i
                            class="el-icon-search"
                            slot="append"
                            @click="searchChange"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--选中摄像机-->
                  <!-- <div class="add-local">
                    <div class="add-amount">已选</div>
                    <div class="add-btn">
                      <el-button>添加到收藏夹</el-button>
                    </div>
                  </div> -->
                  <!--摄像机树-->
                  <div :class="['soc_tree_container']">
                    <device-group-tree
                      ref="deviceTree"
                      @deviceChoose="chooseDevice"
                      @deviceClick="deviceClick"
                      @cameraData="cameraData"
                      @handleCollection="openCollection"
                      :multiCheck="true"
                      :showPercentage="true"
                      :isCollection="true"
                    >
                    </device-group-tree>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="收藏" name="second">
                <div class="second-local tab-main">
                  <div class="local_header">监控点收藏</div>
                  <vidicon-collect
                    class="local-vidicon"
                    ref="vidiconCollect"
                    :addCollectionVisible="false"
                    @deviceChoose="chooseDevice"
                    @change="deviceClick"
                  ></vidicon-collect></div
              ></el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <!--折叠面板-->
        <div class="ioc-collapse">
          <!--云台控制-->
          <div class="collapse-cloud">
            <div
              :class="['expand_menu_header', isCloudActive ? 'expand' : '']"
              @click="handleClickExpandMenu(1)"
            >
              <label style="font-size: 14px">云镜控制</label>
              <div class="expand_icon">
                <i class="el-icon-arrow-up"></i>
              </div>
            </div>
            <div :class="['expand_content', isCloudActive ? '' : 'expand']">
              <div class="control_panel">
                <div class="control-panel_left">
                  <ul class="cloud-handel">
                    <div class="panel_li">
                      <li class="up" @click="handleCloudControl(0x0402, 2)">
                        <span
                          class="icon iconfont-lunan icon-lunan-xiaosanjiaoup"
                        ></span>
                      </li>
                      <li
                        class="right-up"
                        @click="handleCloudControl(0x0802, 2)"
                      >
                        <span
                          class="icon iconfont-lunan icon-lunan-xiaosanjiaoup"
                        ></span>
                      </li>
                      <li class="right" @click="handleCloudControl(0x0502, 2)">
                        <span
                          class="icon iconfont-lunan icon-lunan-xiaosanjiaoup"
                        ></span>
                      </li>
                      <li
                        class="right-down"
                        @click="handleCloudControl(0x0804, 2)"
                      >
                        <span
                          class="icon iconfont-lunan icon-lunan-xiaosanjiaoup"
                        ></span>
                      </li>
                      <li class="down" @click="handleCloudControl(0x0404, 2)">
                        <span
                          class="icon iconfont-lunan icon-lunan-xiaosanjiaoup"
                        ></span>
                      </li>
                      <li
                        class="left-down"
                        @click="handleCloudControl(0x0702, 2)"
                      >
                        <span
                          class="icon iconfont-lunan icon-lunan-xiaosanjiaoup"
                        ></span>
                      </li>
                      <li class="left" @click="handleCloudControl(0x0504, 2)">
                        <span
                          class="icon iconfont-lunan icon-lunan-xiaosanjiaoup"
                        ></span>
                      </li>
                      <li
                        class="left-up"
                        @click="handleCloudControl(0x0702, 2)"
                      >
                        <span
                          class="icon iconfont-lunan icon-lunan-xiaosanjiaoup"
                        ></span>
                      </li>
                      <li class="middle" @click="handleCloudControl(2, 2)">
                        <div class="middle-pause"></div>
                      </li>
                    </div>
                  </ul>
                </div>
                <div class="control-panel_right">
                  <div class="right-row">
                    <div class="right-row_ico">
                      <i
                        title="光圈开"
                        class="icon iconfont-add iconguangquan"
                        @click="handleCloudControl(0x0104)"
                      ></i>
                    </div>
                    <div class="right-row_label">光圈</div>
                    <div class="right-row_ico">
                      <i
                        title="光圈关"
                        class="icon iconfont-add iconguangquan-"
                        @click="handleCloudControl(0x0101)"
                      ></i>
                    </div>
                  </div>
                  <div class="right-row">
                    <div class="right-row_ico">
                      <i
                        title="聚焦近"
                        class="icon iconfont-add iconweiju"
                        @click="handleCloudControl(0x0202)"
                      ></i>
                    </div>
                    <div class="right-row_label">聚焦</div>
                    <div class="right-row_ico">
                      <i
                        @click="handleCloudControl(0x0204)"
                        class="icon iconfont-add iconyuanjing"
                        title="聚焦远"
                      ></i>
                    </div>
                  </div>
                  <div class="right-row">
                    <div class="right-row_ico">
                      <i
                        @click="handleCloudControl(0x0302)"
                        class="icon iconfont-add iconfangda"
                        title="焦距放大"
                      ></i>
                    </div>
                    <div class="right-row_label">焦距</div>
                    <div class="right-row_ico">
                      <i
                        @click="handleCloudControl(0x0304)"
                        class="icon iconfont-add iconsuoxiao"
                        title="焦距缩小"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="control-panel_bar">
                <el-slider
                  v-model="speed"
                  :step="1"
                  :min="1"
                  :max="7"
                ></el-slider>
              </div>
            </div>
          </div>
          <!--录像搜索-->
          <div class="collapse-search">
            <div
              :class="['expand_menu_header', isSearchActive ? 'expand' : '']"
              @click="handleClickExpandMenu(2)"
            >
              <label style="font-size: 14px">录像搜索</label>
              <div class="expand_icon">
                <i class="el-icon-arrow-up"></i>
              </div>
            </div>
            <div :class="['checked_panel', isSearchActive ? '' : 'expand']">
              <div class="video-date-container">
                <label for="">时间范围</label>
                <el-date-picker
                  v-model="dateTimeRange"
                  type="datetimerange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </div>
              <div style="text-align: right; margin-top: 70px">
                <el-button
                  type="primary"
                  size="small"
                  :loading="searchLoading"
                  @click="handleSearchVideos"
                >
                  {{
                    !searchLoading ? $t("video.button.Search") : "录像查询中..."
                  }}
                </el-button>
                <el-button size="small" @click="handleReset"> 重置 </el-button>
                <!-- <el-button
              type="info"
              size="small"
              @click="handleSearchClear"
            >
            {{$t('video.button.reset')}}
            </el-button> -->
              </div>
            </div>
          </div>

          <!-- <el-collapse @change="handleChange" class="ioc-collapse_main">
            <el-collapse-item title="云镜控制" name="1">
              <div class="cloud-control">
                <div class="cloud-control_body">
                  <div class="control-left">
                    <div class="icon iconfont-lunan control-left_content">
                      <i class="xiaosanjiaodown"></i>
                    </div>
                  </div>
                  <div class="control-right"></div>
                </div>
                <div class="cloud-control_ProgressBar"></div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="录像查询" name="2"> </el-collapse-item>
          </el-collapse> -->
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
//import iocBoxSelect from "@/components/common/ioc-box-select/ioc-box-select";
// 设备组设备树
import deviceGroupTree from "./device-group-tree";
// 摄像机收藏
import vidiconCollect from "./VidiconCollect";
import eventBus from "@src/common/utils/eventBus";
import { api } from "@src/modules/video/api.js";
export default {
  components: { deviceGroupTree, vidiconCollect },
  data() {
    return {
      activeName: "first",
      typeData: [
        { label: "按设备组显示", value: 0 },
        { label: "按区域树显示", value: 1 },
      ],
      deviceType: "",
      type: "",
      filterContent: "",
      checkedDevice: true, //判断是设备树还是区域树
      isAddCollection: false,
      isCloudActive: false,
      isSearchActive: false,
      searchLoading: false,
      cameraDataList: [], //选中摄像机
      searchVideoStartTime: "", //查询开始时间
      searchVideoEndTime: "", //查询结束时间
      isVideos: false, //视频插件  暂无
      dateTimeRange: [],
      speed: 4,
      isPtzFlag: false, //云台控制开/关 状态
    };
  },
  watch: {
    filterContent(val) {
      this.checkedDevice === true;
      this.$refs.deviceTree.$refs.appDeviceGroupTree.filter(val);
      // : this.$refs.deviceTree.$refs.appAreaTree.filter(val);
    },
  },
  methods: {
    handleChangeAttrType(data) {},
    handleType(data) {
      console.log(data, data === 0);
      this.deviceType = data;
      data === 0 ? (this.checkedDevice = true) : (this.checkedDevice = false);
      this.$refs.deviceTree.queryDevice(this.checkedDevice);
    },
    //查询摄像机设备
    searchChange(data) {
      console.log(data);
    },
    searchIptChange() {},
    chooseDevice(item, num) {
      console.log("双击", item, this.$refs.deviceTree.dataList);
      if (item.status === "0") {
        this.$message.error(this.$t("ocx.msgInfo35"));
        return;
      }

      //9-25

      this.$emit("open", item, num);
      // this.$player.OcxPlayer.manualPlayLiveAll([{cameraCode: data.thirdCameraId, cameraName: data.name}], 'camera');
      //   this.$refs.mediaPlayer.open({
      //     // cameraCode: item.thirdCameraId,
      //     // cameraName: item.name,
      //     cameraCode: "00845915928845270101#d0aef70ec593472fbfe4b450172689f6",
      //     cameraName: "10.40.147.252",
      //   });
    },
    deviceClick(node) {
      console.log("单击");
    },
    cameraData(data) {
      console.log(data, "====data");
      this.$log.debug(data);
      this.cameraDataList = data;
    },
    openCollection(data) {
      if (!this.isAddCollection) {
        this.camData = data;
        this.isAddCollection = true;
        return;
      }
      console.log(this.isAddCollection, "====isAddCollection");
      this.$emit("openCollection", data);
    },
    refreshCollectionData() {
      this.$refs["vidiconCollect"].refreshCollectionData();
      this.$refs["deviceTree"].queryDevice();
      this.$refs["deviceTree"].resetSelect();
    },
    handleChange(data) {},
    handleClickExpandMenu(data) {
      this.$refs.deviceTree.resetScroll();
      if (data == 1) {
        this.isCloudActive = !this.isCloudActive;
      } else {
        this.isSearchActive = !this.isSearchActive;
      }
    },
    handleClick(tab, event) {
      this.$log.debug(tab, event);
      this.activeNames = tab.name;
      if (tab.name === "first") {
        this.$refs["deviceTree"].resetSelect();
      } else if (tab.name === "second") {
        console.log("]]]]seconc");
        this.$refs["vidiconCollect"].collectionChecked = [];
        this.$refs["vidiconCollect"].queryCollectionData();
      }
    },
    // 云台控制
    handleCloudControl(optCode, modeCode) {
      let obj = this.cameraDataList[0];
      console.log(obj, "--------------obj");
      console.log(optCode, "optCode");
      this.isPtzFlag = true;
      const speed = this.speed;
      let cameraId = obj.thirdCameraId;
      this.$emit("invokingFunction", "handleCloudControl", {
        optCode,
        cameraId,
        speed,
      });
    },
    handleCloudControlStop(cameraCode) {
      this.$emit("invokingFunction", "handleCloudControlStop", cameraCode);
    },
    //录像查询-时间范围 回放
    handleSearchVideos() {
      console.log(
        this.dateTimeRange,
        this.cameraDataList,
        "==this.dateTimeRange"
      );

      if (!this.cameraDataList || !this.cameraDataList.length) {
        this.$message.warning(this.$t("video.message.selectCamera"));
        this.handleClickExpandMenu();
        return;
      }
      if (this.cameraDataList.length > 4) {
        this.$message.warning(this.$t("video.message.chooseCamera"));
        this.handleClickExpandMenu();
        return;
      }
      if (!this.dateTimeRange || !this.dateTimeRange.length > 0) {
        this.$message.warning("请选择查询时间");

        return;
      }
      let params = {
        startTime: this.dateTimeRange[0],
        endTime: this.dateTimeRange[1],
        cameraDataList: this.cameraDataList,
      };
      eventBus.emit("handleBack", params);
      this.searchLoading = true;
      // const _arr = this.cameraDataList.map((item) => {
      //   return item.thirdCameraId;
      // });
      // const date = new Date(this.dateTimeRange);
      // date.setHours(0);
      // date.setMinutes(0);
      // date.setSeconds(0);
      // this.searchVideoStartTime = date.getTime();
      // date.setHours(23);
      // date.setMinutes(59);
      // date.setSeconds(59);
      // this.searchVideoEndTime = date.getTime();
      // const month = date.getMonth() + 1;
      // const params = {
      //   deviceId: _arr,

      //   day: date.getDate() < 10 ? "0" + date.getDate() : date.getDate() + "",
      //   month: month < 10 ? "0" + month : month + "",
      //   year: date.getFullYear() + "",
      // };
      // this.$log.debug("_arr", _arr);
      // this.$log.debug("params", params);
      // this.$fetch(api.queryVideoTimeList, params).then((res) => {
      //   if (!res.success) {
      //     this.$message.error(res.msgContent);
      //   }
      //   if (res.success && res.returnObj && res.returnObj.length) {
      //     let result = {};
      //     let total = 0;
      //     res.returnObj.map((item, index) => {
      //       let name = "";
      //       this.cameraDataList.some((camera) => {
      //         if (camera.thirdCameraId === item.deviceId) {
      //           name = camera.name;
      //           return true;
      //         }
      //         return false;
      //       });

      //       result[index] = item.time_list.map((record) => {
      //         let now = new Date();
      //         now.setHours(1);
      //         record.begin_time;
      //         return {
      //           cameraName: name,
      //           cameraCode: item.deviceId,
      //           StartTime: Dates.format(record.begin_time, "yyyyMMddhhmmss"),
      //           EndTime: Dates.format(record.end_time, "yyyyMMddhhmmss"),
      //         };
      //       });
      //       if (item.time_list && item.time_list.length) {
      //         total += item.time_list.length;
      //         const param = {
      //           deviceId: item.deviceId,
      //           startTime: item.time_list[0].begin_time,
      //           endTime: item.time_list[0].end_time,
      //         };
      //         setTimeout(() => {
      //           this.$refs.mediaPlayer.handlePlayBackVideo(param);
      //         }, (index + 1) * 4000);
      //       }
      //     });
      //     if (total === 0) {
      //       this.$message.warning(this.$t("video.message.noSearchVideo"));
      //     } else {
      //       this.queryBackData = JSON.stringify(result);
      //       this.isVideos = true;
      //     }
      //   }
      //   setTimeout(() => {
      //     this.searchLoading = false;
      //   }, 500);
      // });
    },
    //录像查询重置
    handleReset() {},
  },
};
</script>
<style lang="scss" scope >
@import "~@src/common/assets/style/mixin";
// 实时播放左侧
.content-left {
  float: left;
  // width: 272px;
  height: 100%;
  //过滤条件
  .filter_div {
    display: inline-flex;
    .el-input__inner,
    .el-select-dropdown__item {
      font-size: 7px !important;
    }

    .el-select {
      width: 200px;
    }
    .filter_select {
      .el-input {
        border: 1px solid #62687d !important;
      }
    }
  }
  .filter-input {
    display: inline-flex;
    border: 1px solid #62687d;
    border-radius: 1px;
    .filter-input_btn {
      width: 30px;
      text-align: center;
      border: none;
      color: #9aa6c1;
      cursor: pointer;
      line-height: 32px;
      font-size: 8px;
      @include set_theme_color(background-color, main-content-bg-color);
      i:hover {
        color: #3e76e6;
      }
    }
  }
  // overflow-y: auto;
  .left-flex {
    display: flex;
    flex: 1;
    height: 100%;
    min-height: 0;
  }

  .tabs {
    @extend .left-flex;
    display: flex;

    .el-tabs {
      width: 100%;
      padding: 9px 16px;
    }

    // .el-tabs__item {
    //   padding: 0;
    // }

    .el-tabs__content {
      height: calc(100% - 55px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
}
.soc_video_left_panel {
  width: 370px;
  // width: 100%;
  height: 100%;
}

.soc_panel_container {
  // padding: 20px;
  color: #fff;
}
.soc-card {
  @include set_theme_color(background-color, left-menu-bg-color);
  .video_left_header {
    width: 100%;
  }
  .first-video {
    height: 100%;
    .soc_tree_container {
      height: 100%;
      margin-top: 16px;
    }
    // .soc_tree_hide {
    //   height: calc(100% - 8px);
    // }
    // .soc_tree_hidecloud {
    //   height: calc(100% - 224px);
    // }
    // .soc_tree_hidesearch {
    //   height: calc(100% - 334px);
    // }
  }
  .tab-main {
    margin-top: 1px;
    height: 100%;
    // height: 420px;
    color: #fff;
  }
}
//折叠面板
.ioc-collapse {
  z-index: 2;
}
.local_header {
  padding-left: 10px;
  border-left: #3e76e6 3px solid;
}
.local-vidicon {
  padding-top: 20px;
}
.soc_tab_panel {
  display: flex;
  // padding: 16px 0px;
  .filter-input {
    margin-left: 1px;
  }
}
//新增收藏夹
.add-local {
  display: flex;
  margin-top: 16px;
  font-size: 12px;
  justify-content: space-between;
}
//云台
.control_panel {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  .control-panel_right {
    display: flex;
    flex-direction: column;
    .right-row {
      padding: 10px;
      display: inline-flex;
      height: 50px;
      .right-row_label {
        padding: 0 4px;
      }
      .right-row_ico {
        cursor: pointer;
      }
    }
  }
}
.control-panel_bar {
  padding: 10px 40px;
}
.cloud-handel {
  list-style: none;
  margin: 0;
  padding: 0;
  right: 45px;
  top: 45px;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  @include set_theme_color(background-color, main-content-bg-color);
  position: absolute;
  color: rgb(139, 142, 152);
  //   .top {
  //     right: 50px;
  //   }

  //   .right {
  //     right: 43px;
  //   }
  .panel_li {
    position: relative;
    width: 100%;
    height: 100%;
    li {
      cursor: pointer;
      position: absolute;
      // height: 51px;
      // width: 110px;
      background-size: 100% 100%;

      &:hover {
        color: #4386ff;
        //   font-size: 40px !important;
      }
      &.middle {
      }

      &:first-child {
        right: 20px;
        top: -25px;
      }

      // &:nth-child(2) {
      //     top: 33px;
      //     left: 11px;
      //     transform: rotate(-45deg);
      // }

      &:nth-child(2) {
        right: -15px;
        top: -15px;
        transform: rotate(45deg);
      }

      // &:nth-child(4) {
      //     left: 11px;
      //     top: 111px;
      //     transform: rotate(-135deg);
      // }

      &:nth-child(3) {
        right: -25px;
        top: 25px;
        transform: rotate(90deg);
      }
      &:nth-child(4) {
        bottom: -15px;
        right: -15px;
        //   top: 118px;
        transform: rotate(135deg);
      }
      &:nth-child(5) {
        left: 23px;
        bottom: -25px;
        transform: rotate(180deg);
      }
      &:nth-child(6) {
        bottom: -15px;
        left: -15px;
        transform: rotate(-135deg);
      }
      &:nth-child(7) {
        //   top: 118px;
        left: -25px;
        top: 25px;
        transform: rotate(-90deg);
      }
      // &:nth-child(6) {
      //     left: 89px;
      //     top: 111px;
      //     transform: rotate(135deg);
      // }

      &:nth-child(8) {
        left: -15px;
        top: -15px;
        transform: rotate(-45deg);
      }
    }
    .middle {
      left: 17px;
      top: 17px;
    }
    .middle-pause {
      width: 25px;
      height: 25px;
      right: 15.5px;
      border-radius: 5px;
      background: rgb(139, 142, 152);
    }
    .middle-pause:hover {
      background: rgba(64, 122, 238, 1);
    }
    // &:last-child {
    //     left: 89px;
    //     top: 33px;
    //     transform: rotate(45deg);
    // }
  }
}

.expand_menu_header {
  height: 34px;
  padding: 0 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  // background-color: #1A2137;
  @include set_theme_color(background-color, input-default-bg-color);
  align-items: center;
  font-size: 16px;
  line-height: 16px;
  cursor: pointer;

  &.expand {
    .expand_icon {
      transform: rotate(180deg);
    }
  }

  // .expand_icon {
  //   i {
  //     color: $soc-primary-color;
  //   }
  // }
}

.expand_content {
  height: 300px;
  transition: height 0.3s;
  -webkit-transition: height 0.3s;
  @include set_theme_color(background-color, main-content-bg-color);
  // background-color: $soc-color-background;
  display: flex;
  flex-direction: column;

  &.expand {
    height: 0;
    overflow: hidden;
  }
}

.control-panel_left {
  position: relative;
  width: 150px;
  height: 150px;
  //   padding: 20px;
  background-color: #0d121c;
  border-radius: 75px;
}
//录像查询
.checked_panel {
  @include set_theme_color(background-color, main-content-bg-color);
  padding: 20px;
  height: 200px;

  &.expand {
    padding: 0px;
    height: 0;
    overflow: hidden;
  }
}
.video-date-container {
  color: rgb(152, 155, 153);
}
.el-date-editor {
  width: 220px !important;
  margin-left: 10px;
}

.content {
  margin-left: 16px;
  // padding-left: 19px;
  @extend .left-flex;
  flex-direction: column;
}
// background: ;
</style>
